import React from 'react';
import {EventTextField, AnyBaseEvent} from 'entities/event';

interface Props {
    eventData: AnyBaseEvent;
    fieldToShow: EventTextField;
}


const BaseTextSampleModalContents = React.memo<Props>(
    ({eventData, fieldToShow}) => (
        <div>
            {eventData[fieldToShow]}
        </div>
    ),
);


export default BaseTextSampleModalContents;
